<main [class.error]="showError">
    <div class="container">
        <div class="element" [class.selected-value]="value && isValueFromList">
            <input
                type="text"
                [value]="value"
                [readonly]="isValueFromList"
                [attr.maxlength]="14"
                (input)="handInput($event)">
            <app-icon *ngIf="value && isValueFromList" (click)="deleteItem($event)">close</app-icon>
        </div>
    </div>
    <app-icon (click)="addProduct()">search</app-icon>
</main>
